module.exports = __webpack_public_path__ + "static/img/hangye_1@2x.9f68e79a.png";